import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";

import {
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { FormQuestion } from "../../events-screen/event-page-models/form-question";
import { receiptPageSubmitReceiptModalFormObject } from "./receipt-page-submit-receipt-modal-form-object";
import { FormGroup } from "@angular/forms";
import { GenericFormComponent } from "../../../form/generic-form/generic-form.component";
import { DepositData } from "../receipt-page-models/PaperPaymentItem";
import { receiptMockCheckFromBatch } from "../receipt-util-mock/receipt-mock-check-from-batch";
import { CheckPaymentItem } from "../receipt-page-models/CheckPaymentItem";
import { PaperPaymentType } from "../receipt-page-models/PaperPaymentType";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { EventValidationService } from "../../../_services/eventsServices/eventValidation.service";
import { Router } from "@angular/router";
import { sleep } from "../../../_helpers/sleep";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { ReceiptManagementService } from "../../../_services/receipt-management.service";
import { EventSerializerService } from "../../../_services/eventsServices/eventSerializer.service";
import { Epoc } from "../../../_models/Epoc";

@Component({
  selector: "receipt-page-submit-receipt-modal",
  templateUrl: "./receipt-page-submit-receipt-modal.component.html",
  styleUrls: ["./receipt-page-submit-receipt-modal.component.scss"],
})
export class ReceiptPageSubmitReceiptModalComponent implements OnInit {
  public static readonly modalOptions: NgbModalOptions = {
    backdropClass: "user-management-form-main-modal-container",
    backdrop: true,
    windowClass: "edit-user-window-class",
  };
  public static ShowErrorOnAmountAfterTouchedDelayMs: number = 1500;
  public SHOW_UPLOAD_FILE = false;
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();
  public errorMessage: string = "";
  public warningMessage: string = "";
  public translations$: Observable<ITranslations>;
  public formQuestions: FormQuestion[] =
    receiptPageSubmitReceiptModalFormObject;
  public selectedFile: File | null = null;
  public submitReceiptFormGroup: FormGroup | null = null;
  public isFormValid: boolean = false;
  public checksData: CheckPaymentItem[] = [];
  public isSaving: boolean;
  public depositData: DepositData | null = null;
  public isSingleReceipt: boolean = false;
  private amountTouchedTime: Date | null = null;
  private errorTypes = {
    theAmountIsLessThanReceiptAmount:
      "שימו לב: סכום ההפקדה אינו מכסה את סכום הקבלה",
    cannotDepositCheckPartially: "לא ניתן להפקיד צ׳ק בסכום חלקי",
    referenceNumberExceedsRemainingAmount:
      "סכום האסמכתא גדול מהסכום שנותר להפקיד",
    theAmountNeedsToBeGreaterThan0: "על סכום ההפקדה להיות גבוה יותר מ 0",
    amountMustBeWholeNumber: "הסכום חייב להיות מספר שלם",
  };

  constructor(
    protected receiptManagementService: ReceiptManagementService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef,
    private translationService: TranslationService,
    private sessionManagerService: SessionManagerService,
    private router: Router
  ) {
    this.translations$ = this.translationService.translations;
  }

  @Input("modalDepositInput")
  public set modalDepositDataInput(depositData: DepositData) {
    this.depositData = depositData;
    this.checksData = this.getCheckDataFromDepositData(depositData);
  }

  public ngOnInit() {
    this.submitReceiptFormGroup = GenericFormComponent.buildFormGroup(
      this.formQuestions
    );
    this.isSingleReceipt =
      this.depositData && !!this.depositData.specificPaymentItemId;

    this.submitReceiptFormGroup.valueChanges.subscribe((vc) => {
      this.updateFormValidity(vc);
    });
    if (this.sessionManagerService.isDevModeActive) {
      document.addEventListener("keydown", (event) => {
        if (event.code !== "KeyA" || !event.altKey) {
          return;
        }
        this.submitReceiptFormGroup.patchValue({
          depositAmount: this.calculateLeftToDepositAmount(),
          depositDate: "30/10/25",
          transActionReferenceNumber: "123456",
        });
      });
    }
  }

  public async submitForm($event: any) {
    const isCheque = this.checksData.length > 0;
    this.isSaving = true;
    const formValues = this.submitReceiptFormGroup.value as {
      transActionReferenceNumber: number;
      depositDate: string;
      depositAmount: number;
      comments: string;
    };

    const saveResponse =
      await this.receiptManagementService.depositCashOrChequeReceipt({
        ...formValues,
        depositDate: EventSerializerService.dateToEpoc(
          formValues.depositDate
        ) as Epoc,

        ...this.depositData,
        isCheque,
      });
    this.isSaving = false;

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    if (saveResponse.success) {
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "סיום",
        modalText: `  סגירת הקבלה בוצעה בהצלחה!`,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        this.closeParentEventModal();
      });
      return;
    } else {
      const isDisconnected =
        saveResponse.error && saveResponse.error.status === 401;

      const errorMessage =
        await EventValidationService.convertServer400ErrorsToReadableText(
          saveResponse.error
        );
      const modalText = isDisconnected
        ? "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש."
        : ` השמירה נכשלה. פרטים:   ${"\n" + errorMessage}`;
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "שגיאה",
        modalText,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        if (isDisconnected) {
          this.closeParentEventModal();
          setTimeout(() => this.router.navigate(["/login"]), 1000);
        }
      });
      this.isSaving = false;
    }
  }
  public async closeParentEventModal() {
    this.modalAction.emit("close");
  }
  public setSelectedFile($event: File) {
    this.selectedFile = $event;
    this.updateFormValidity(this.submitReceiptFormGroup.value);
  }

  private getCheckDataFromDepositData(
    depositData: DepositData
  ): CheckPaymentItem[] {
    if (depositData.paymentBatch.paymentType !== PaperPaymentType.check) {
      return [];
    }
    return receiptMockCheckFromBatch(depositData.paymentBatch);
  }

  private calculateLeftToDepositAmount(): number {
    if (this.depositData.specificPaymentItemId) {
      const specificReceipt = this.depositData.paymentBatch.paymentsItems.find(
        (item) => item.id === this.depositData.specificPaymentItemId
      );
      if (specificReceipt) {
        return specificReceipt.leftForDeposit;
      }
    } else {
      return this.depositData.paymentBatch.leftForDeposit;
    }
  }

  private updateFormValidity(formValues: any) {
    const isCheque = this.checksData.length > 0;
    let isValid = true;
    let errorMessage = "";
    let warningMessage = "";
    if (this.isFormValidCheck(formValues) === false) {
      isValid = false;
    }
    if (this.selectedFile === null && this.SHOW_UPLOAD_FILE) {
      isValid = false;
    }
    if (formValues.depositAmount && formValues.depositAmount % 1 !== 0) {
      isValid = false;
      errorMessage = this.errorTypes.amountMustBeWholeNumber;
    }
    if (
      formValues.depositAmount &&
      this.calculateLeftToDepositAmount() !== formValues.depositAmount
    ) {
      if (!this.amountTouchedTime) {
        this.amountTouchedTime = new Date();
      }
      if (
        isCheque ||
        this.calculateLeftToDepositAmount() < formValues.depositAmount
      ) {
        isValid = false;
      }

      if (
        new Date().getTime() - this.amountTouchedTime.getTime() >
        ReceiptPageSubmitReceiptModalComponent.ShowErrorOnAmountAfterTouchedDelayMs
      ) {
        if (!errorMessage) {
          if (!isCheque) {
            if (
              this.calculateLeftToDepositAmount() > formValues.depositAmount
            ) {
              warningMessage = this.errorTypes.theAmountIsLessThanReceiptAmount;
            } else {
              errorMessage =
                this.errorTypes.referenceNumberExceedsRemainingAmount;
            }
          } else {
            errorMessage =
              this.calculateLeftToDepositAmount() > formValues.depositAmount
                ? this.errorTypes.cannotDepositCheckPartially
                : this.errorTypes.referenceNumberExceedsRemainingAmount;
          }
        }
      }
    }
    this.errorMessage = errorMessage;
    this.warningMessage = warningMessage;
    this.isFormValid = isValid;
  }

  private isFormValidCheck(formValues: any): boolean {
    const isCheque = this.checksData.length > 0;

    let isValid = true;
    if (
      !formValues.depositAmount ||
      formValues.depositAmount === 0 ||
      formValues.depositAmount < 0
    ) {
      isValid = false;
    }
    for (const question of this.formQuestions) {
      if (question.isRequired) {
        const value = formValues[question.fieldName];
        if (
          value === null ||
          value === undefined ||
          value === "" ||
          (Array.isArray(value) && value.length === 0)
        ) {
          isValid = false;
          break;
        }
      }
    }
    return isValid;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-submit-receipt-modal/receipt-page-submit-receipt-modal.component.ts